
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","viewBox":"0 0 61.9 61.6"}},[_c('path',{attrs:{"fill":"#1e824c","d":"M58.4 4C54.2-.6 46.9-.9 42.2 3.4c0 0-35.8 36.4-35.9 36.5-.1.1-.1.2-.2.2l-.1.3-4.9 17.5c-.3 1.4.6 2.8 1.9 3.1h1.3l17.3-4.8c.7-.1 36.3-35.9 36.3-35.9 4.5-4.3 4.8-11.6.5-16.3zM16.1 52.5L7.2 55l2.5-8.9 6.4 6.4zm40-40.1c0 1.7-.6 3.2-1.8 4.4L21 50l-8.8-8.8L45.6 8c1.2-1.2 2.8-1.9 4.4-1.8 1.7 0 3.2.7 4.4 2 1.1 1 1.7 2.5 1.7 4.2z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      